import { styled } from 'react-alicerce-components';

export const Container = styled.div`
  .main-navbar {
    height: 130px;
    width: 100%;
    align-items: center;
  }

  [role='tabpanel'] {
    /* margin-bottom: 8rem; */
    /* height: 100%;     */
    height: calc(100vh - 120px);
  }

  .pagination-content-icon {
    background-color: #8f9bb3 !important;

    i svg {
      fill: #fff !important;
    }
  }
`;
